export default {
  version: '2.0.0',
};



// WEBPACK FOOTER //
// ./assets/js/cf-ajax-form/info.js